import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/fbcdd5a2e46d40600f5cef3877799025/15d0368bf2bd14ba66c09a19f7ba3c72.jpeg"
          alt="강남 프리미엄 인테리어"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/40" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-5 md:px-12 pb-28">
        <div className="max-w-2xl mx-auto md:mx-0 text-center md:text-left">
          <div className="inline-flex items-center gap-2 border-2 border-[#c9a84c] text-[#c9a84c] text-xs md:text-sm tracking-[0.15em] md:tracking-[0.2em] uppercase px-4 md:px-5 py-2 md:py-2.5 rounded-full mb-6 md:mb-8 font-extrabold drop-shadow-md">
            <span className="w-1.5 h-1.5 md:w-2 md:h-2 rounded-full bg-[#c9a84c] inline-block" />
            푸른감성 · 책임 시공
          </div>
          <h1 className="text-3xl sm:text-4xl md:text-7xl font-light text-white leading-snug md:leading-tight mb-4 md:mb-4" style={{ fontFamily: "'Noto Serif KR', serif" }}>
            진심을 담은 시공,<br />
            <span className="font-semibold">초록빛 감각을 더하다</span>
          </h1>
          <p className="text-[#c9a84c] text-xs md:text-lg mb-3 md:mb-3 leading-relaxed tracking-wide font-medium drop-shadow-md whitespace-nowrap overflow-hidden text-ellipsis">
            feel green · 진심을 담은 시공, 초록빛 감각을 더하다
          </p>
          <p className="text-white/60 text-xs md:text-base mb-10 md:mb-10 leading-relaxed">
            feel green의 경험과 신뢰로 완성하는 프리미엄 인테리어.<br />
            책임 시공의 역사를 경험하세요.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 md:gap-4 items-center md:items-start">
            <Link
              to="/estimate"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-3 bg-[#c9a84c] text-[#0d0d0d] font-bold text-sm px-8 py-3.5 md:py-4 rounded-full whitespace-nowrap cursor-pointer hover:bg-[#b8973b] transition-all duration-300"
            >
              <i className="ri-calculator-line" />
              무료 견적 받기
            </Link>
            <Link
              to="/portfolio"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-3 border border-white/40 text-white text-sm px-8 py-3.5 md:py-4 rounded-full whitespace-nowrap cursor-pointer hover:border-white hover:bg-white/10 transition-all duration-300"
            >
              <i className="ri-image-line" />
              시공 사례 보기
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll Down Indicator - hidden on mobile */}
      <div className="hidden md:flex absolute bottom-28 right-10 z-10 flex-col items-center gap-2 cursor-pointer group"
        onClick={() => window.scrollTo({ top: window.innerHeight, behavior: 'smooth' })}
      >
        <span className="text-white/50 text-[10px] tracking-[0.25em] uppercase rotate-90 mb-2 group-hover:text-[#c9a84c] transition-colors">Scroll</span>
        <div className="flex flex-col items-center gap-1">
          <div className="w-px h-10 bg-gradient-to-b from-white/0 to-white/50 group-hover:to-[#c9a84c]/70 transition-colors" />
          <div
            className="w-5 h-5 flex items-center justify-center text-white/50 group-hover:text-[#c9a84c] transition-colors"
            style={{ animation: 'bounceDown 1.6s ease-in-out infinite' }}
          >
            <i className="ri-arrow-down-s-line text-lg" />
          </div>
        </div>
      </div>

      <style>{`
        @keyframes bounceDown {
          0%, 100% { transform: translateY(0); opacity: 0.5; }
          50% { transform: translateY(6px); opacity: 1; }
        }
      `}</style>

      {/* Stats Bar */}
      <div className="absolute bottom-0 left-0 right-0 z-10 bg-[#c9a84c]">
        <div className="max-w-[1400px] mx-auto px-4 md:px-12 py-4 md:py-5 grid grid-cols-4 gap-2 md:gap-6">
          {[
            { num: '30년+', label: '역사' },
            { num: '2,400+', label: '시공 완료' },
            { num: '99%', label: '고객 만족도' },
            { num: '2년', label: 'A/S 보증' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-lg sm:text-2xl md:text-3xl font-bold text-[#0d0d0d]">{stat.num}</div>
              <div className="text-[#0d0d0d]/70 text-[10px] sm:text-xs mt-0.5 md:mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
